module.exports = __webpack_public_path__ + "static/Inno-computer-c978e6278af4467e36d1a2fe621c5c0f.png";